import { computed } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import type { Location } from '@ds/types/Location'

import { useRouteLocationWithLocale } from '~/composables/useRouteLocationWithLocale'
import { CMS } from '~/scopes/cms/routes-names'

export const useJapanNavigation = () => {
  const { market } = useMarketplace()
  const withLocale = useRouteLocationWithLocale()

  const isJapanMarket = computed(
    () => market.countryCode === MarketCountryCode.JP,
  )

  const qualityPageUrl = computed<Location>(() =>
    withLocale({
      name: CMS.QUALITY,
    }),
  )

  const backupJpUrl = computed<Location>(() =>
    withLocale({ name: CMS.EVENT, params: { pageName: 'backup' } }),
  )

  const inStoreRepairJpUrl = computed<Location>(() =>
    withLocale({ name: CMS.EVENT, params: { pageName: 'in-store-repair' } }),
  )

  return { isJapanMarket, qualityPageUrl, backupJpUrl, inStoreRepairJpUrl }
}
